import { METHOD } from 'services/method'

export const API_REQUEST_AWB = {
    SHIPPING_METHODS: {
        api: '/v1/master/shipping-methods',
        method: METHOD.GET,
    },
    LIST: {
        api: '/v1/dashboard-admin/request-awb/list',
        method: METHOD.POST,
    },
    PRINT_LABEL_LIST: {
        api: '/v1/dashboard-admin/request-awb/print-label/list',
        method: METHOD.POST,
    },
    BULK_REQUEST_AWB: {
        api: '/v1/dashboard-admin/request-awb',
        method: METHOD.POST,
    },
    MANUAL_PRINT_LABEL: {
        api: '/v1/dashboard-admin/request-awb/print-label/manual',
        method: METHOD.POST,
    },
    PREVIEW_PRINT_LABEL: {
        api: '/v1/dashboard-admin/request-awb/print-label/preview',
        method: METHOD.POST,
    },
    BULK_PRINT_LABEL: {
        api: '/v1/dashboard-admin/request-awb/print-label',
        method: METHOD.POST,
    },
}
